export default "__VITE_ASSET__DlMsWyu4__"